<template>
  <div>
    <!-- 渲染html -->
    <div class="wrapClass">
      <!-- 头部 -->
      <div class="content-bg">
        <img src="../assets/qcx-a1.png" />
        <img src="../assets/qcx-a2.png" />
        <img src="../assets/qcx-a3.png" />
        <img src="../assets/qcx-a4.png" />  
        <div class="nav_box">
          <div class="down_box">
            <span class="down_btn" @click="isRegister">
              下载倾城秀APP
            </span>
          </div>
        </div>
        <van-popup v-model="show" :overlay="true">
          
            <div class="formbox">
              <div class="register-logo">
                <div class="flex_center">
                  <img src="../assets/qcx-logo.png" class="logo"/>
                  倾城秀
                </div> 
              </div>
              <van-form ref="formData" @submit="onSubmit">
                <div class="forminfo">
                  <van-cell-group>
                    <van-field
                      v-model="formData.phone"
                      type="tel"
                      center
                      clearable
                      class="cell-field"
                      placeholder="请输入手机号"
                      :rules="[
                        { required: true, message: '请输入手机号' },
                        {
                          pattern: /^1[3456789]\d{9}$/,
                          message: '手机号码格式错误！'
                        }
                      ]"
                    >
                      <template #left-icon>
                        <img src="../assets/phone-icon.png" class="phone-icon"/>
                      </template>
                    </van-field>
                  </van-cell-group>
                </div>
                <div class="forminfo">
                  <van-cell-group>
                    <!-- 验证码 -->
                    <van-field
                      v-model="formData.verifyCode"
                      center
                      clearable
                      class="cell-field"
                      placeholder="请输入验证码"
                      :rules="[{ required: true, message: '请输入验证码' }]"
                    >
                      <template #left-icon>
                        <img src="../assets/code-icon.png" class="code-icon"/>
                      </template>
                    </van-field>
                  </van-cell-group>

                  <template>
                    <div @click.stop="sendCode()" class="codeBtn">
                      <span class="codeText">{{ codeBtnText }}</span>
                    </div>
                  </template>
                </div>
                <div class="save_btn">
                  <!-- <div style="margin: 16px;"> -->
                  <van-button
                    round
                    block
                    type="info"
                    native-type="submit"
                    class="down_btn"
                  >
                    下载
                  </van-button>
                </div>
              </van-form>
            </div>
        </van-popup>
      </div>
      
    </div>
  </div>
</template>

<script>
import Qs from 'qs'
import { Base64 } from "js-base64";
import wx from "weixin-js-sdk";
import html2canvas from "html2canvas";
import { isPone } from "../utils/util";
// import {sendValidate} from '@/http/index.js'

import Toast from "vant/lib/toast";
import Icon from "vant/lib/icon";
import Dialog from "vant/lib/dialog";
import Search from "vant/lib/search";
import List from "vant/lib/list";
import Button from "vant/lib/button";
import Cell from "vant/lib/cell";
import Popup from "vant/lib/popup";

import "vant/lib/toast/style";
import "vant/lib/icon/style";
import "vant/lib/dialog/style";
import "vant/lib/search/style";
import "vant/lib/list/style";
import "vant/lib/button/style";
import "vant/lib/cell/style";
import "vant/lib/popup/style";
document.title = "新潮视频汇聚场"
export default {
  components: {
    "van-popup": Popup,
    "van-icon": Icon,
    "van-dialog": Dialog,
    "van-search": Search,
    "van-list": List,
    "van-cell": Cell,
    "van-button": Button
  },

  data() {
    return {
      data: null,
      isIos: false,
      isAndroid: false,
      code:"", //邀请码
      show:false, //默认隐藏
      loading:false, //防止多次点击
      formData: {
        phone: "", //联系电话
        verifyCode: "" //验证码
      },
      btnOptFlag: false, //获取验证码按钮禁用标识
      codeBtnText: "获取",
      outTime: 60, // 设置发送验证码倒计时时间
      timer: null,
      headers:{} //请求头
    };
  },
  watch: {},
  created() {
  },

  mounted() {
     let code = this.$route.query.code; //获取需要的邀请码
     this.code = code; //赋值邀请码
     this.setHeader() //设置请求头
  },
  deactivated() {
    console.log("deactivated");
  },
  methods: {
    /**
     * 设置请求头
     */
    setHeader() {
      this.headers["Authorization"] = `Basic c3dvcmQ6c3dvcmRfc2VjcmV0`; //系统授权码
      this.headers["Content-Type"] = "application/x-www-form-urlencoded"; //请求方式
      this.headers["User-Type"] = "app"; //app登录需要传类型
    },
    //发送验证码
    sendCode() {
      if (!isPone(this.formData.phone)) {
        Toast("请输入正确的手机号");
        return;
      }
      if (this.btnOptFlag) return;
      this.btnOptFlag = true; //禁用发送验证码按钮
      //发送请求
    var parmas ="phone=" + this.formData.phone + "&code=login";
      this.$axios.post('/api/blade-resource/sms/endpoint/send-validate',parmas).then((res) => { 
      　　console.log(res)
           if (res.data.code == 200) {
            console.log("验证码请求成功")
              Toast(res.data.msg);
              //收到短信再进行
              if (!this.timer) {
                this.timer = setInterval(() => {
                  this.codeBtnText = this.outTime + "s";
                  this.outTime = this.outTime - 1;
                  if (this.outTime < 0) {
                    //倒计时结束，重置时间器
                    clearInterval(this.timer);
                    this.codeBtnText = "获取";
                    this.outTime = 60;
                    this.timer = null;
                    this.btnOptFlag = false;
                  }
                }, 1000); //每秒执行一次
              }
            } else {
              Toast(res.data.msg);
            }
      }).catch((err) => {
      　　console.log(err)
      })

    },
    //注册
    onSubmit(){
      console.log("保存")
      let parmas = {
        grant_type:'password',
        scope:'all',
        tenantId: "545606",
        username: this.formData.phone,
        loginType:'1',
        sourceCode:'tencent',
        verCode:this.formData.verifyCode,
        inviteCode:this.code,
      }
      this.$axios({
        headers:this.headers,
        method: 'post',
        url: '/api/blade-auth/oauth/token',
        data: Qs.stringify(parmas)
    }).then((res) => { 
      　　console.log("res",res)
           if (res.data.access_token) {
            console.log("注册成功");
            Toast("注册成功");
            this.isDown();
            } else {
              Toast(res.msg);
            }
      }).catch((err) => {
      　　console.log("err",err)
          let res = err.response;
          Toast(res.data.msg);
      })
    },
    //注册
    isRegister(){
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
      if (isIOS) {
        //如果是微信环境 就提示去浏览器
        if(isWeixin){
          alert('请在浏览器上打开')
          return
        }else{
          this.show = true; //注册流程
        }
      }
      if (isAndroid) {
        console.log("是安卓")
        this.show = true; //注册流程
      }
      
    },
    //下载
    isDown() {
      // 如果邀请码存在
      if(this.code){
        // 点击复制邀请码
        var input = document.createElement("input"); // 直接构建input
        input.value = this.code; // 设置内容为邀请码
        console.log("input.value",input.value )
        document.body.appendChild(input); // 添加临时实例
        input.setAttribute("readonly", "readonly");//设置只读，否则移动端使用复制功能时可能会造成软件盘弹出
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
      }

      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
      if (isAndroid) {
          let hidden =
          window.document.hidden ||
          window.document.mozHidden ||
          window.document.msHidden ||
          window.document.webkitHidden;
          if (typeof hidden == "undefined" || hidden == false) {
            // button.href="https://a.app.qq.com/o/simple.jsp?pkgname=com.ruanyiit.facefusion"
            // 上面的https是应用地址比如说应用宝，pkgname=应用名称
            window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.ruanyiit.facefusion"; //安卓应用市场地
          }
        }
        if (isIOS) {
            let hidden =
            window.document.hidden ||
            window.document.mozHidden ||
            window.document.msHidden ||
            window.document.webkitHidden;
            if (typeof hidden == "undefined" || hidden == false) {
            // button.href="https://apps.apple.com/cn/app/你应用的名字/id11646468"
            // 上面的应用后面的id是你上传到appstore后，在App Store Connect的App信息界面会有一个Apple ID。添加到id后面即可。
            window.location.href = "https://apps.apple.com/cn/app/id1600040585";
            }
        }
    },
    

  }
};
</script>

<style lang="less" scoped>
@import "../assets/iconfont/font_set_read_bar/iconfont.css";
@import "../styles/common.css";
@import "../styles/style.css";
/* 阻止文本复制 */
* {
  -o-user-select: none; /* 设置或检索是否允许用户选中文本 */
  -khtml-user-select: none; /* 苹果浏览器文本选择 */
  -webkit-user-select: none; /* 所有的文本选择 */
  -ms-user-select: none; /*IE浏览器*/
  user-select: none; /*用户是否能够选中文本*/
  -webkit-touch-callout: default; /* 系统默认浏览器长按链接与图片弹出菜单 */
}
.wrap {
  min-height: 100vh;
  /* background-color: white; */
}
.content-bg {
    width: 100vw;
    min-height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* background: linear-gradient(to bottom,#ffc2d8,rgb(255, 255, 255)); */
    /* background-image: url("../assets/bg_2.png"); */
    background-size: cover;
  }
.content-bg img {
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    width: 100%;
    height: 100%;
}
.nav_logo{
  position: absolute;
  right: 5%;
  top: 2%;
  width:45px;
  height: 45px;
  z-index: 1002;
}
.nav_logo .logo{
  width:100%;
  height: 100%;
}
.nav_box {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 2%;
  width: 100%;
  z-index: 1002;
}
.flex_box {
  display: flex;
  align-items: center;
  justify-content: center;
}
.en_box {
  padding: 0 35px 19px 35px;
  text-align: left;
}
.studytip {
  display: block;
  font-size: 20px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #3f99c4;
  line-height: 28px;
}
.study_title2 {
  display: block;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
}
.study_title3 {
  display: block;
  font-size: 12px;
  color: #959595;
  line-height: 30px;
}
.study_en {
  display: block;
  margin-bottom: 4px;
}
.study_tip {
  display: block;
  font-size: 12px;
  line-height: 20px;
  color: #959595;
}
.update_box {
  padding: 0 35px;
  margin-bottom: 22px;
  text-align: left;
}
.update_box span {
  display: block;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  white-space: pre-wrap;
}
.update_nav {
  height: 80px;
  overflow-y: auto;
}
.down_box {
  padding: 0 3%;
  color: #ffffff;
}
/* to right */
.down_btn {
  display: block;
  height: 44px;
  line-height: 44px;
  background: linear-gradient(96deg, #f55252 0%, #50cdd5 100%);
  border-radius: 5px;
  left: 0;
  bottom: 0;
}

.van-popup {
  min-height: 8%;
  /* box-shadow: 0px -2px 10px #ececec; */
}

.van-slider {
  margin: 0px 10px;
}
.zi-add::after {
  content: "-";
}
.zi-sub::after {
  content: "+";
}

.bold {
  line-height: 36px;
  font-weight: bold;
}
.fontWeight {
  font-weight: bold;
}

.padLR20 {
  padding: 0 20px;
  margin-top: 10px;
}

.van-icon-arrow::before {
  color: rgb(255, 107, 70);
  border-radius: 50%;
  content: "\F00A";
  background-color: white;
}

.formbox {
  width:80vw;
  min-height: 30vh;
  padding: 7%;
  .register-logo{
    width:100%;
    display: block;
    margin:10px 0 30px 0;
    .logo{
      width:33px;
      height: 33px;
      margin-right: 12px;
    }
    .logo-name{
      width:44px;
      height: 17.5px;
    }
  }
  .forminfo {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    overflow: hidden;
    box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.08);
    border-radius: 5px;
  }
  .cell-field{
    border-radius: 10px;
    display: flex;
    align-items: center;
  }
  .codeBtn {
    width: 25%;
    height: 19px;
    line-height: 19px;
    margin-right: 5%;
    font-size: 12px;
    background: #EDEDED;
    
    .codeText{
    //   font-size: 0.5em;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      opacity: 0.6;
    }
  }
  .save_btn{
    margin:30px 0 10px 0;
    background: linear-gradient(92deg, #808EFB, #E869C6);
    box-shadow: 0px 0px 12px 1px rgba(145, 139, 244, 0.36);
    border-radius: 10px;
  }
  .down_btn{
    border:none
  }
  .phone-icon{
    display: block;
    width:10px;
    height: 14px;
    line-height: inherit;
  }
  .code-icon{
    display: block;
    width:13px;
    height: 14px;
    line-height: inherit;
  }
  
}

.cell {
  padding: 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* border-bottom: 1px solid #f2f2f2; */
}
</style>




// WEBPACK FOOTER //
// src/view/qcxShareShow.vue